var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"alt":"Jamesway Logo","contain":_vm.contain,"src":_vm.useMini
      ? _vm.miniCompanyImage
      : _vm.useDark
      ? _vm.darkCompanyImage
      : _vm.lightCompanyImage,"transition":"scroll-y-transition","size":_vm.size,"width":_vm.size ? _vm.size : _vm.useMini ? 45 : 100,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }